<template>
  <div :class="theme+' appContainer'" id="app">
    <router-view />
    <audio
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      autoplay
      muted
      ref="messageAudio"
      v-if="notifyAudio"
    >
      <source :src="notifyAudio" />
    </audio>
  </div>
</template>

<script>
import { addPermissionRoute, resetRouter } from '@/router/index'
export default {
  name: 'App',
  data () {
    return {
      loginForm: {},
      orgTheme: '',
      notifyAudio: ''
    }
  },
  computed: {
    currentEntryCode: function () {
      return this.$store.getters['menuInfo/entryCode'] || ''
    },
    userAccount: function () {
      return this.$store.getters['userInfo/account'] || 'guest'
    },
    theme: function () {
      let theme = this.$store.getters['userInfo/userTheme'] || this.$store.getters['systemInfo/theme'] || 'lightTheme'
      this.changeTheme(theme)
      return theme
    },
    projectInfo: function () {
      return this.$store.getters['systemInfo/systemInfo'] || {}
    }
  },
  methods: {
    receiveMessage ({ type, message }) {
      this.notifyAudio = this.$common.notifySoundMap[type] || this.$common.notifySoundMap.default
      console.log('receiveMessage', this.notifyAudio)
      this.$nextTick(async () => {
        if (this.$refs['messageAudio']) {
          try {
            console.log("this.$refs['messageAudio']", this.$refs['messageAudio'])
            this.$refs['messageAudio'].src = this.notifyAudio
            await this.$refs['messageAudio'].play()
          } catch (error) {
            console.log(error)
          }
        }
      })

      // 不是现在所处的房间就新增未读消息
      // if (news.roomId !== this.$store.state.conversation.currentConversation.roomId || JSON.stringify(this.$store.state.conversation.currentConversation) === '{}') {
      //   this.$store.dispatch('conversation/SET_UNREAD_NUM', {type: 'add', data: news})
      // }
    },
    changeTheme: function (currentTheme) {
      if (this.$route.name != 'login' && this.orgTheme != '' && this.orgTheme && this.orgTheme != currentTheme) {
        //涉及变量污染问题 需要刷新
        window.location.reload()
      } else {
        import(`@/assets/static/theme/${currentTheme}/theme.less`)
      }
      this.orgTheme = currentTheme
    },

    restAllRouter: function (params) {
      addPermissionRoute(true)
    },
    enterAsOther: function (user) {
      let that = this
      let params = new this.$URLSearchParams()
      params.append("account", this.userAccount)
      params.append("jumpAccount", user)
      this.$axios.post(this.$apis.systemManager.userManager.runAsOther, params).then(res => {
        if (res.success) {
          that.handleInfo(res.result || {}, true)
          this.getUserMenuAndPermisson(true, false)
          that.$bus.$emit('reloadSocket')
          // that.$bus.$emit('reload')
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log(err)
        that.$Message.error("进入失败！")
      })
    },
    getFullMenus: async function () {
      let that = this
      that.$axios.post(this.$apis.common.getFullMenus).then(res => {
        if (res.success) {
          // 菜單
          this.$store.dispatch("menuInfo/updateMenuInfoParams", { key: 'allMenus', value: res.result || [] })
          console.log('current route', window.location.pathname)
          let pathname = window.location.pathname
          let path = pathname + window.location.search
          addPermissionRoute(true, res.result || []).then(() => {
            console.log('current Routes', that.$router.getRoutes())
            // 此部分操作是为了页面刷新的重新进入以前的链接
            if (pathname && ['/login'].indexOf(pathname) <= 0) {
              if ('/' == pathname) {
                let defaultUrl = this.$store.getters['userInfo/defaultUrl']
                console.log('user defaultUrl', defaultUrl)
                if (defaultUrl) {
                  this.$router.push({ path: defaultUrl })
                } else {
                  // 获取默认的第一个菜单
                  let systemSettingMenus = this.$store.getters['menuInfo/entryMenus'] || {}
                  let menus = systemSettingMenus.system_menu || systemSettingMenus.config_menu || []
                  if (menus.length > 0) this.$router.push({ name: menus[0].pathName })
                  else this.$router.push({ name: 'Main' })
                }
              } else {
                that.$router.push({ path: path })
              }
            }
          })
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log(err)
        that.$Message.error('加载菜单信息失败！')
      })
    },
    getUserMenuAndPermisson: function (needChange, toPortal) {
      let that = this
      try {
        that.$axios.post(this.$apis.systemManager.userManager.getUserMenuAndPermission).then(async res => {
          if (res.success) {
            // 菜單
            await that.$store.dispatch("menuInfo/updateMenuInfoParams", [{ key: 'entryMenus', value: res.result.menus || {} }, { key: 'userEntries', value: res.result.projectEntries || [] }])
            //按鈕權限 菜单权限
            await that.$store.dispatch("userInfo/updateUserInfoParams", [{ key: 'btnPermissions', value: res.result.permissions || [] }, { key: 'menuPermissions', value: res.result.menuPermissions || [] }])
            if (needChange) {
              console.log('that.$route', this.projectInfo.portalPath)
              //如果有门户 进入门户页面 否则获取用户默认路径
              if (this.projectInfo.hasPortal && toPortal) {
                console.log('that.$router', that.$route)
                that.$router.push({ path: this.projectInfo.portalPath })
              } else {
                //没有门户 代表就默认的系统设置入口 默认
                console.log('res.result.defaultUrl', res.result.defaultUrl)
                if (res.result.defaultUrl) {
                  that.$store.dispatch("userInfo/updateUserInfoParams", { key: 'defaultUrl', value: res.result.defaultUrl })
                  that.$router.push({ path: res.result.defaultUrl })
                } else {
                  // 获取默认的第一个菜单
                  let systemSettingMenus = res.result.menus || {}
                  let menus = systemSettingMenus.system_menu || systemSettingMenus.config_menu || []
                  if (menus.length > 0) {
                    if (menus[0].children && menus[0].children.length > 0) {
                      let openMenu = menus[0].children[0]
                      if (openMenu.children && openMenu.children.length > 0) {
                        this.$router.push({ name: openMenu.children[0].pathName })
                      } else {
                        this.$router.push({ name: openMenu.pathName })
                      }
                    } else {
                      that.$router.push({ name: menus[0].pathName })
                    }
                    // that.$router.push({ name: menus[0].pathName })
                  } else that.$router.push({ name: 'Main' })
                }
              }
            }
          } else {
            that.$Message.error(res.message)
          }
        }).catch(function (err) {
          console.log(err)
          that.$Message.error('加载用户入口信息失败！')
        })
      } catch (error) {
        console.log('getUserMenuAndPermisson error', error)
      }

    },
    // 返回本身账号
    backSelf: function () {
      let that = this
      that.$axios.post(this.$apis.systemManager.userManager.backSelf).then(res => {
        if (res.success) {
          that.handleInfo(res.result || {}, false)
          that.getUserMenuAndPermisson(true, false)
          // that.$bus.$emit('reload')
          that.$bus.$emit('reloadSocket')
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log(err)
        that.$Message.error('返回失败！')
      })
    },
    handleInfo: function (data, runAsOther) {
      let that = this
      let userInfo = data.userInfo || {}
      this.loginForm = {
        id: userInfo.id,
        password: null,
        avatar: userInfo.avatar,
        backAccount: this.userAccount,
        name: userInfo.name,
        account: userInfo.account,
        defaultUrl: userInfo.defaultUrl,
        email: userInfo.email,
        telePhone: userInfo.telePhone,
        description: userInfo.description,
        isAdmin: userInfo.isAdmin,
        runAsOther: runAsOther,
        userTheme: userInfo.theme
      }
      // if(userInfo.avatar) this.loginForm.avatar = userInfo.avatar;
      this.$store.dispatch("userInfo/updateUserInfo", this.loginForm)

      let projectInfo = data.projectInfo || {}
      let systemSetting = data.systemSetting || {}
      projectInfo.cockpitThemeCode = data.cockpitThemeCode
      let authModel = data.authModel || 'server'
      projectInfo.authModel = authModel
      projectInfo.hasPortal = systemSetting.hasPortal || false
      projectInfo.portalPath = systemSetting.portalPath || '/entry'
      projectInfo.captchaEnable = systemSetting.captchaEnable == undefined ? false : systemSetting.captchaEnable
      projectInfo.encryptPassword = systemSetting.encryptPassword == undefined ? true : systemSetting.encryptPassword
      if (projectInfo.headerBgId) projectInfo.headerBgPath = process.env.VUE_APP_API_ROOT + this.$apis.fileServerApi.getFile + '?id=' + projectInfo.headerBgId
      if (projectInfo.logoId) projectInfo.logoPath = process.env.VUE_APP_API_ROOT + this.$apis.fileServerApi.getFile + '?id=' + projectInfo.logoId

      if (systemSetting.loginBg) projectInfo.loginBg = systemSetting.loginBg
      projectInfo.systemCode = data.systemCode
      that.$store.dispatch("updateAuthModel", authModel)
      that.$store.dispatch("systemInfo/updateSystemInfo", projectInfo)
      that.$store.dispatch("systemSupport/updateSystemSupport", data.supportPathConfig || {})
    },
    handleLogout: function (isToLogin) {
      let that = this
      this.$axios.post(this.$apis.systemManager.userManager.logout).then((res) => {
        if (res.success) {
          this.$store.dispatch('resetAll')
          if (isToLogin)
            that.$router.push({ path: '/login' })
        } else {
          that.$Message.error({
            content: res.message,
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('handleLogout error', err)
        that.$Message.error("退出失败！")
      })
    },
    logout: function (params) {
      let that = this
      if (params && params == true) {
        this.$Modal.confirm({
          title: '提醒',
          content: '<p>请确认是否退出登录！</p>',
          okText: '退出',
          // cancelText: ''
          onOk: () => {
            that.handleLogout(true)
          }
        })
      } else {
        this.handleLogout(false)
      }
    },
    preventBack () {
      // 可以在这里添加你想要执行的操作
      console.info('返回按钮已禁用！')
      // // 阻止默认的返回行为
      history.pushState(null, null, location.href)
    }

  },
  beforeMount () {
    console.log('app beforeMount')
    // 加载全量菜单
    if (this.$route.meta?.structure != 'FULL') {
      console.log('refresh fullMenus...')
      this.getFullMenus()
    }
  },
  mounted () {
    let _this = this
    // window.addEventListener('popstate', this.preventBack)
    this.$bus.$off('logout')
    this.$bus.$on('logout', (params) => {
      _this.logout(params)
    })
    this.$bus.$off('statusChange')
    this.$bus.$on('statusChange', async (param) => {
      console.log("statusChange", param)
      _this.receiveMessage(param)
    })
    this.$bus.$off('changeMenuPermission')
    this.$bus.$on('changeMenuPermission', async (param1, param2) => {
      console.log("changeMenuPermission needChange", param1)
      console.log("changeMenuPermission toPortal", param2)
      _this.getUserMenuAndPermisson(param1, param2)
    })
    this.$bus.$off('restRouter')
    this.$bus.$on('restRouter', (params) => {
      console.log("restRouter", params)
      _this.restAllRouter(params)
    })
    this.$bus.$off('runAsOther')
    this.$bus.$on('runAsOther', (params) => {
      console.log("runAsOther", params)
      _this.enterAsOther(params)
    })
    this.$bus.$off('backSelf')
    this.$bus.$on('backSelf', (params) => {
      console.log("backSelf", params)
      _this.backSelf(params)
    })
    this.$bus.$off('changeMenu')
    this.$bus.$on("changeMenu", () => {
      console.log("changeMenu")
      // debugger
      _this.getFullMenus()
    })
  }
}
</script>

<style>
#app {
  height: 100%;
  width: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
